// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"c4055595","977":"c10ffbcb"}[chunkId] + ".chunk.js";
};